<template>
  <div>
    <my-dialog
      form-title="图片"
      :dialog-carted="showPhotos"
      :width="600"
      :is-show-footer="false"
      @confirmOk="closeDialog"
    >
      <template #content>
        <div style="display: none">{{ allPhotos }}</div>
        <!-- 上面一行代码 调用 allPhotos, 不可以注释-->
        <div v-if="allPhotos.length">
          <!-- 如果有照片的话 -->
          <patient-image-swiper :all-photos="allPhotos"/>
        </div>
        <div v-else>
          <img src="@/assets/photos/640.png" style="height: 360px" alt="">
        </div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog.vue";
import PatientImageSwiper from "@/components/Swiper/PatientImageSwiper";
import { mapState } from "vuex";

export default {
  name: "ImageShow",
  components: {
    MyDialog,
    PatientImageSwiper
  },
  props: {
    showPhotos: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },

  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo",
    }),
    allPhotos() {
      const { nurseImgList = [], mmimgList = [], mmsaveList = [] } = this.patient;
      return nurseImgList.concat(mmimgList, mmsaveList);
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  }
};
</script>

<style scoped>

</style>
